export const pxToRem = (value: number): string => value ? `${Number.parseFloat((value / 16).toFixed(4))}rem` : '0rem'
